import React from "react";
import { MapPin, Mail, Phone } from "lucide-react";
import { ContactForm } from "../components/ContactForm";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation();
  const info = [
    { icon: MapPin, label: "address", value: "Jurišićeva 19, 10000 Zagreb" },
    { icon: Mail, label: "email", value: "trendiarh@gmail.com" },
    { icon: Phone, label: "phone", value: "091 5400 194 · 091 183 2002" },
  ];

  return (
    <main className="pt-[72px]">
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 pt-16 md:pt-24">
        <span data-testid="contact-eyebrow" className="inline-block px-4 py-1.5 rounded-full border border-black/25 text-[10px] font-medium uppercase tracking-[0.16em] mb-8">
          {t("contact.eyebrow")}
        </span>
        <h1 data-testid="contact-heading" className="font-display font-bold text-[2.5rem] sm:text-6xl md:text-7xl lg:text-8xl xl:text-[9rem] leading-[0.88] tracking-tight mb-6">
          {t("contact.title")}
        </h1>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 md:px-10 py-14 md:py-16">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20">
          {/* Info */}
          <div className="reveal-on-scroll">
            <p data-testid="contact-intro" className="font-display text-[clamp(1.3rem,3vw,2.2rem)] leading-[1.2] tracking-tight mb-12 text-balance">
              {t("contact.intro")}
            </p>
            <div className="space-y-8">
              {info.map((it, i) => (
                <div key={it.label} style={{ "--reveal-delay": `${i * 100}ms` }} className="reveal-on-scroll flex items-start gap-4 border-t border-black/10 pt-6">
                  <div className="w-11 h-11 rounded-full bg-[#0e0e10] text-white flex items-center justify-center shrink-0">
                    <it.icon size={17} />
                  </div>
                  <div className="min-w-0">
                    <div data-testid={`contact-info-label-${i}`} className="text-[10px] uppercase tracking-[0.16em] text-[#0e0e10]/45 mb-1">{t(`contact.${it.label}`)}</div>
                    <div data-testid={`contact-info-${i}`} className="text-lg font-display break-words">{it.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Form */}
          <ContactForm />
        </div>
      </section>
    </main>
  );
};

export default Contact;
